import { SidePanelViewMode } from '../../../../SidePanel/types';
import {
    postPaymentScheduleRequest,
    putPaymentScheduleRequest,
} from '../../../../../../resources/contract/actions';
import {
    getContract,
    shouldRecreatePaymentSchedule as shouldRecreatePaymentScheduleSelector,
    getContractPaymentSchedule,
    getPostPaymentScheduleStatus,
    getPreviousPaymentSchedule,
    getPutPaymentScheduleStatus,
} from '../../../../../../resources/contract/selectors';
import { ContractId } from '../../../../../../resources/contract/types';
import { useAppSelector } from '../../../../../../shared/redux';

import { FilledPaymentSchedule } from './FilledPaymentSchedule';

import { PaymentSchedule as NewOrRecreatePaymentSchedule } from './index';

type Props = {
    contractId: ContractId;
    onSuccess?: () => void;
    viewMode?: SidePanelViewMode;
};

export function PaymentScheduleStep({ contractId, onSuccess, viewMode }: Props): JSX.Element {
    const contract = useAppSelector(getContract);
    const shouldRecreatePaymentSchedule = useAppSelector(shouldRecreatePaymentScheduleSelector);
    const initialPaymentSchedule = useAppSelector(
        shouldRecreatePaymentSchedule ? getPreviousPaymentSchedule : getContractPaymentSchedule,
    );
    const paymentScheduleRequestStatus = useAppSelector(
        shouldRecreatePaymentSchedule ? getPutPaymentScheduleStatus : getPostPaymentScheduleStatus,
    );

    if (contract === null || contract.paymentSchedule === null) {
        return (
            <NewOrRecreatePaymentSchedule
                contractId={contractId}
                initialPaymentSchedule={initialPaymentSchedule}
                paymentScheduleRequestStatus={paymentScheduleRequestStatus}
                submit={postPaymentScheduleRequest}
                onSuccess={onSuccess}
                viewMode={viewMode}
            />
        );
    }
    if (shouldRecreatePaymentSchedule) {
        return (
            <NewOrRecreatePaymentSchedule
                contractId={contractId}
                initialPaymentSchedule={initialPaymentSchedule}
                paymentScheduleRequestStatus={paymentScheduleRequestStatus}
                submit={putPaymentScheduleRequest}
                onSuccess={onSuccess}
                viewMode={viewMode}
            />
        );
    }

    return (
        <FilledPaymentSchedule contractId={contractId} onComplete={onSuccess} viewMode={viewMode} />
    );
}
